// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"496fe5dd","154":"0cbc9b61","500":"db1c5641","717":"343779b8"}[chunkId] + ".chunk.js";
};